import type { VoidFunction } from 'src/lib/types';

import { SavedDocumentView, type SavedDocumentViewProps } from './SavedDocumentView';
import { SavedDocumentViewStoreContainer } from './store';

interface ContainerProps extends SavedDocumentViewProps {
  projectId: string;
  // Called on the first access error from any call; the comments are then gone for this user.
  onAccessLost?: VoidFunction;
}

/**
 * The saved document with its comments and ratings. It renders inside the host's `CustomSlate`, so
 * the host owns the editor and its value.
 */
export const Container = ({ projectId, onAccessLost, ...props }: ContainerProps) => (
  <SavedDocumentViewStoreContainer
    // The comments belong to one project; another project starts from an empty store.
    key={projectId}
    projectId={projectId}
    onAccessLost={onAccessLost}
  >
    <SavedDocumentView {...props} />
  </SavedDocumentViewStoreContainer>
);
